/* Keep Shopify's native option IDs and variant events as the source of truth. */
if (!customElements.get('purrivio-option-select')) {
  class PurrivioOptionSelect extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const { signal } = this.abort;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-purri-option]');
        if (!button) return;
        const select = this.querySelector('select');
        if (!select) return;
        select.value = button.dataset.purriOption;
        this.querySelector('details').open = false;
        this.querySelector('summary').focus();
        select.dispatchEvent(new Event('change', { bubbles: true }));
        this.sync();
      }, { signal });
      this.addEventListener('keydown', (event) => {
        const details = this.querySelector('details');
        if (!details) return;
        if (event.key === 'Escape') {
          details.open = false;
          details.querySelector('summary').focus();
          event.preventDefault();
        } else if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
          const options = [...this.querySelectorAll('[data-purri-option]')];
          if (!options.length) return;
          event.preventDefault();
          details.open = true;
          const index = options.indexOf(document.activeElement);
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? options.length - 1 :
            (index + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
          options[next].focus();
        }
      }, { signal });
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) {
          const details = this.querySelector('details');
          if (details) details.open = false;
        }
      }, { signal });
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this, { childList: true, subtree: true });
      this.sync();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
    }
    sync() {
      const select = this.querySelector('select');
      if (!select) return;
      let details = this.querySelector('details');
      const signature = [...select.options].map(o => o.value + o.textContent).join('|');
      if (!details || this.signature !== signature) {
        details?.remove();
        details = document.createElement('details');
        details.className = 'purri-option-picker';
        const summary = document.createElement('summary');
        summary.id = select.id + '-trigger';
        details.append(summary);
        const list = document.createElement('div');
        list.className = 'purri-option-list';
        for (const option of select.options) {
          const button = document.createElement('button');
          button.type = 'button';
          button.dataset.purriOption = option.value;
          button.textContent = option.textContent.trim();
          list.append(button);
        }
        details.append(list);
        this.append(details);
        this.signature = signature;
      }
      const name = select.labels?.[0]?.textContent.trim() || '';
      const text = select.selectedOptions[0]?.textContent.trim() || '';
      const summary = details.querySelector('summary');
      if (summary.textContent !== text) summary.textContent = text;
      summary.setAttribute('aria-label', name + ': ' + text);
      this.querySelectorAll('[data-purri-option]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.purriOption === select.value));
      });
      select.hidden = true;
      this.classList.add('purri-enhanced');
    }
  }
  customElements.define('purrivio-option-select', PurrivioOptionSelect);
}
